import React, { useContext } from 'react';
import { FeatureFlag } from '@lib/state';
import { PropertyFeatureContext } from './featureFlagProvider';

export const useFeatureEnabled = (feature: FeatureFlag) => {
  const flags = useContext(PropertyFeatureContext);
  const requestedFlag = feature.toLocaleLowerCase();
  return flags.some(flag => flag.toLocaleLowerCase() === requestedFlag);
};
